export default import.meta.ROLLDOWN_FILE_URL_QmDJfzjSQ1Yyan8BZrNlzA